/* ModalSocialNetworkLink.js */

import React, { useCallback, useState } from 'react';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import Strings from '../../translations/Translations';
import { SiApplemusic, SiFacebook, SiInstagram, SiSpotify, SiTiktok, SiTwitter, SiYoutube, SiYoutubemusic } from "react-icons/si";
import { useForm } from 'react-hook-form';
import { IoLinkOutline } from 'react-icons/io5';

export default function ModalSocialNetworkLink({ open, setOpen, callback, socialNetwork, type }) {
  const toggle = useCallback(() => setOpen(!open), [open, setOpen]);
  const { register, getValues, reset } = useForm();
  const [optionAccountPage, setOptionAccountPage] = useState('account');

  const getTitle = useCallback(() => {
    let title = Strings('add_link'); // Default title
    let icon = <></>;
    if (socialNetwork) {
      if (socialNetwork === 'instagram') { icon = <SiInstagram size='1.2em' />; title = Strings('add_instagram_link'); }
      else if (socialNetwork === 'facebook') { icon = <SiFacebook size='1.2em' />; title = Strings('add_facebook_link'); }
      else if (socialNetwork === 'youtube') { icon = <SiYoutube size='1.2em' />; title = Strings('add_youtube_link'); }
      else if (socialNetwork === 'tiktok') { icon = <SiTiktok size='1.2em' />; title = Strings('add_tiktok_link'); }
      else if (socialNetwork === 'twitter') { icon = <SiTwitter size='1.2em' />; title = Strings('add_twitter_link'); }
      else if (socialNetwork === 'spotify') { icon = <SiSpotify size='1.2em' />; title = Strings('add_spotify_link'); }
      else if (socialNetwork === 'apple_music') { icon = <SiApplemusic size='1.2em' />; title = Strings('add_applemusic_link'); }
      else if (socialNetwork === 'youtubemusic') { icon = <SiYoutubemusic size='1.2em' />; title = Strings('add_youtube_music_link'); }
      else if (socialNetwork === 'custom') { icon = <IoLinkOutline size='1.2em' />; title = Strings('add_website'); }
    }
    return <>{icon} {title}</>;
  }, [socialNetwork]);

  const addLink = useCallback(() => {
    if (type) {
      let label, url;

      if (type === 'url') {
        const { link } = getValues();
        if (link && socialNetwork) {
          if (socialNetwork === 'custom' || socialNetwork === 'spotify' || socialNetwork === 'applemusic' || socialNetwork === 'youtubemusic') {
            url = link;
            if (socialNetwork === 'custom') {  label = Strings('website'); }
            else if (socialNetwork === 'youtubemusic') { label = Strings('youtube_busic'); }
            else if (socialNetwork === 'applemusic') { label = Strings('apple_music'); }
            else if (socialNetwork === 'spotify') { label = Strings('spotify'); }
          }
        }
      } else if (type === 'account') {
        const { account } = getValues();
        if (account && socialNetwork) {
          if (socialNetwork === 'instagram') {
            label =  Strings('instagram');
            url = `https://instagram.com/${account}`;
          } else if (socialNetwork === 'tiktok') {
            const username = account.replaceAll('@', '');
            label =  Strings('tik_tok');
            url = `https://tiktok.com/@${username}`;
          } else if (socialNetwork === 'twitter') {
            label =  Strings('twitter');
            url = `https://twitter.com/${account}`;
          }
        }
      } else if (type === 'account_page') {
        const { account_page } = getValues();
        if (account_page && socialNetwork) {
          if (socialNetwork === 'facebook') {
            label = Strings('facebook');
            if (optionAccountPage === 'account') { url = `https://facebook.com/${account_page}`; }
            else if (optionAccountPage === 'page') { url = `https://facebook.com/pages/${account_page}`; }
          } else if (socialNetwork === 'youtube') {
            label = Strings('youtube');
            const username = account_page.replaceAll('@', '');
            if (optionAccountPage === 'account') { url = `https://youtube.com/@${username}`; }
            else if (optionAccountPage === 'page') { url = `https://youtube.com/channel/${username}`; }
          }
        }
      }

      if (label && url && callback) {
        callback(label, url);
        reset();
      }
    }
  }, [getValues, callback, socialNetwork, reset, type, optionAccountPage]);

  return (
    <Modal isOpen={open} toggle={toggle} size='md'>
      <ModalHeader toggle={toggle}>
        {getTitle(socialNetwork)}
      </ModalHeader>
      <ModalBody>
        {type && type === 'url' && (
          <Row>
            <Col sm={12}>
              <small>{Strings('link')}</small>
              <input className='form-control' {...register('link')}/>
            </Col>
          </Row>
        )}
        {type && type === 'account' && (
          <Row>
            <Col sm={12}>
              <small>{Strings('account_username')}</small>
              <input className='form-control' {...register('account')}/>
            </Col>
          </Row>
        )}
        {type && type === 'account_page' && (
          <Row>
            <Col sm={12}>
              <div className='d-inline-block mr-10px'>
                <input
                  type="radio"
                  name="option_account_page"
                  id="account"
                  value="account"
                  checked={optionAccountPage === 'account'}
                  onChange={() => {}}
                  onClick={() => setOptionAccountPage('account')}
                  className='mr-5px'
                />
                <label htmlFor="account">{Strings('account_username')}</label>
              </div>
              <div className='d-inline-block'>
                <input
                  type="radio"
                  name="option_account_page"
                  id="page"
                  value="page"
                  checked={optionAccountPage === 'page'}
                  onChange={() => {}}
                  onClick={() => setOptionAccountPage('page')}
                  className='mr-5px'
                />
                <label htmlFor="page">{Strings('page_channel')}</label>
              </div>
            </Col>
            <Col sm={12}>
              <small>
                {optionAccountPage === 'account' && Strings('account_username')}
                {optionAccountPage === 'page' && Strings('page_channel')}
              </small>
              <input className='form-control' {...register('account_page')}/>
            </Col>
          </Row>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={toggle}>
          {Strings('cancel')}
        </Button>
        <Button className='pb-btn-1' onClick={addLink}>
          {Strings('add')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
